import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AppPage, PageAccessService } from '../../core/service/page-access.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent {
  showpopup: boolean = false;
  username!: string;
  point: number = 0;
  menu: AppPage[] = [];

  constructor(private router: Router, private access: PageAccessService) {
    // เมนูแสดงเฉพาะหน้าที่เข้าได้ (รายงานเข้าจากปุ่มในหน้าแรก จึงไม่อยู่ในเมนู)
    this.menu = this.access.visiblePages.filter(p => p.key !== 'report');
    this.point = Number(localStorage.getItem('point')) || 0;
    this.username = localStorage.getItem('fullname') || 'user';



  }

  @HostListener('document:click')
  closePopup() {
    this.showpopup = false;
  }

  triggerpopup() {
    this.showpopup = !this.showpopup
  }

  logout() {
    localStorage.clear();
    this.router.navigate(['/account/login']);
  }
}
